import React from "react";
import { formatCurrency } from "../../util";
import loadStatus from "../../util/loadStatus";
import Loading from "../loading/Loading";

const ProjectReportsTable = ({ projects, title, loading }) => {
  return (
    <div className="text-text-1/80">
      <h5 className="mb-5">{`${title} - Projects Report`} </h5>
      <div className="w-full overflow-auto">
        <table className=" overflow-auto w-full">
          <thead className="uppercase">
            <tr className="!bg-transparent !border !border-bkg2">
              <th className="!bg-transparent px-2 py-0.5 !border-r !border-r-bkg2">
                No.
              </th>
              <th className="!bg-transparent px-2 py-0.5 !border-r !border-r-bkg2 min-w-56">
                Title
              </th>
              <th className="!bg-transparent px-2 py-0.5 !border-r !border-r-bkg2 min-w-52">
                Community
              </th>
              <th className="!bg-transparent px-2 py-0.5 !border-r !border-r-bkg2 min-w-52">
                Donors
              </th>
              <th className="!bg-transparent px-2 py-0.5 !border-r !border-r-bkg2 min-w-36">
                Status
              </th>
              <th className="!bg-transparent px-2 py-0.5 !border-r !border-r-bkg2 min-w-48">
                Step
              </th>
              <th className="!bg-transparent px-2 py-0.5 !border-r !border-r-bkg2 min-w-36">
                Total Cost
              </th>
              <th className="!bg-transparent px-2 py-0.5 !border-r !border-r-bkg2 min-w-56">
                Provincial Remark
              </th>
            </tr>
          </thead>
          <tbody className="text-text-1/70">
            {projects.length > 0 ? (
              projects.map((item, index) => (
                <tr
                  key={index}
                  className="!bg-transparent !border !border-bkg2"
                >
                  <td className="!bg-transparent !border-r !border-r-bkg2  !px-2 !py-0.5">
                    {index + 1}
                  </td>
                  <td className="!bg-transparent !border-r !border-r-bkg2  !px-2 !py-0.5 text-nowrap">
                    {item.name.length >= 30
                      ? item.name.slice(0, 35).toUpperCase() + "....."
                      : item.name.toUpperCase()}
                  </td>
                  <td className="!bg-transparent !border-r !border-r-bkg2  !px-2 !py-0.5">
                    {item.community}
                  </td>
                  <td className="!bg-transparent !border-r !border-r-bkg2  !px-2 !py-0.5">
                    {item.community}
                  </td>
                  <td className="!bg-transparent !border-r !border-r-bkg2  !px-2 !py-0.5">
                    {item.status}
                  </td>
                  <td className="!bg-transparent !border-r !border-r-bkg2  !px-2 !py-0.5">
                    {item.stage.stage_number +
                      "." +
                      item.stage.step_number +
                      ". " +
                      item.stage.step}
                  </td>
                  <td className="!bg-transparent !border-r !border-r-bkg2  !px-2 !py-0.5">
                    {item.currency
                      ? `${item.symbol} ${formatCurrency(item.total_cost)}`
                      : `${formatCurrency(item.total_cost)}`}
                  </td>
                  <td className="!bg-transparent !border-r !border-r-bkg2  !px-2 !py-0.5">
                    {item.provincial_remarks || "N/A"}
                  </td>
                </tr>
              ))
            ) : loading === loadStatus.loading ? (
              <tr className="!bg-transparent !border !border-bkg2">
                <td colSpan={8}>
                  <div className="flex justify-center items-center h-40 text-text-1/60 text-center">
                    <Loading />
                  </div>
                </td>
              </tr>
            ) : (
              <tr className="!bg-transparent !border !border-bkg2">
                <td colSpan={8}>
                  <div className="flex justify-center items-center h-40 text-text-1/60 text-center">
                    <p>No Content Available</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProjectReportsTable;
